import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button, Alert } from 'react-bootstrap';
import { usePosition } from '../hooks/usePosition';
import LoadingSpinner from './LoadingSpinner';
import { fontSize } from '@mui/system';

export const LocationGuard = ({ children, showPermissionAlert = true }) => {
    const { 
        isLoading, 
        error, 
        permissionState, 
        hasPosition, 
        requestPosition,
        refreshPosition,
        requestLocationPermission,
        isFirefox,
        handleFirefoxPermissionAccepted
    } = usePosition();

    if (isLoading) {
        return (
            <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                <LoadingSpinner />
                <p className="ms-3">Verificando permisos de ubicación...</p>
            </div>
        );
    }

    const hasLocationPermissions = hasPosition && permissionState === 'granted';

    return (
        <div>
            {/* Mostrar alerta de permisos si no los tiene y está habilitado */}
            {!hasLocationPermissions && showPermissionAlert && (
                <div className="d-flex justify-content-center mt-4">
                    <div className="responsive-alert">
                        <Card.Body>
                            <Alert variant="danger">
                                {/* Layout horizontal: ícono - textos - botón */}
                                <div className="d-flex align-items-center justify-content-between">
                                    {/* Ícono a la izquierda */}
                                    <div className="me-3">
                                        <img src="/location_off.svg" alt="Ubicación desactivada" width="41" height="41" />
                                    </div>
                                    
                                    {/* Textos en el centro */}
                                    <div className="flex-grow-1 text-start">
                                        <div className="fw-bold mb-1" style={{fontSize: '20px'}}>Activa tu ubicación para registrar tu asistencia</div>
                                        <p className="mb-0">
                                            Da clic en <strong>activar ubicación</strong> y sigue las instrucciones de tu navegador.
                                        </p>
                                    </div>
                                    
                                    {/* Botón a la derecha */}
                                    <div className="ms-3">
                                        <Button 
                                            variant="primary" 
                                            onClick={requestLocationPermission}
                                            // size="lg"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? 'Procesando...' : 'Activar ubicación'}
                                        </Button>
                                    </div>
                                </div>
                            </Alert>
                            
                            {/* <p className="mb-3 text-primary text-center">
                                {error && !isLoading ? error : 'Para habilitar tu registro de asistencia activa tu ubicación.'}
                            </p> */}
                        </Card.Body>
                    </div>
                </div>
            )}
            
            {/* Siempre renderizar children, pero inyectar props de ubicación */}
            {React.isValidElement(children) 
                ? React.cloneElement(children, { 
                    hasLocationPermissions,
                    locationError: error,
                    isLocationLoading: isLoading
                })
                : children
            }
        </div>
    );
};

LocationGuard.propTypes = {
    children: PropTypes.node,
    showPermissionAlert: PropTypes.bool
};